import { makeStyles } from "@material-ui/core/styles";

export default makeStyles({
  pastPerformances: {
    display: "grid",
    position: "relative",
    width: "fit-content",
    paddingLeft: 20,
    fontFamily: "ArialNarrowBold, ArialNarrow",
    fontWeight: 600,
    fontSize: 12,
    letterSpacing: -1
  },
  lastWorkouts: {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gridGap: 10,
    padding: "10px 0"
  },
  lastWorkout: {
    display: "flex",
    alignItems: "end",
    justifyContent: "center",
    backgroundColor: "#eeeeee",
    border: "1px solid #bababa",
    height: 20,
    borderRadius: 5,
    letterSpacing: -1
  },
  lifetimeStats: {
    justifyContent: "end",
    height: 20,
    marginRight: -80,
    "& span:first-child": {
      paddingLeft: 0
    }
  },
  ppsTable: {
    display: "table",
    borderCollapse: "collapse"
  }
});
